import React from 'react'

const UnderBottomFooter = () => {
  return (
    <div className='under-bottom'>
        <span>
            Turn off the scene to see building's underbelly
        </span>
    </div>
  )
}

export default UnderBottomFooter